// 用户API
import Request from '../base'
export default {
  saveType (Type) {
    return Request.post('/eberuser/userapi/user/orgType/save', Type)
  },
  deleteType (options) {
    return Request.post('/eberuser/userapi/user/orgType/delete', options)
  },
  loadType (options) {
    return Request.post('/eberuser/userapi/user/orgType/load', options)
  },
  listType (options) {
    return Request.post('/eberuser/userapi/user/orgType/list', options)
  },
  saveTypeRule (options) {
    return Request.post('/eberuser/userapi/user/orgTypeRule/save', options)
  },
  deleteTypeRule (options) {
    return Request.post('/eberuser/userapi/user/orgTypeRule/delete', options)
  },
  saveOrg (Org) {
    return Request.post('/eberuser/userapi/user/org/save', Org)
  },
  deleteOrg (options) {
    return Request.post('/eberuser/userapi/user/org/delete', options)
  },
  loadOrg (options) {
    return Request.post('/eberuser/userapi/user/org/load', options)
  },
  listOrg (options) {
    return Request.post('/eberuser/userapi/user/org/list', options)
  },
  listOrgId (options) {
    return Request.post('/eberuser/userapi/user/org/listId', options)
  },
  saveCode (options) {
    return Request.post('/eberuser/userapi/user/orgCode/save', options)
  },
  loadCode (options) {
    return Request.post('/eberuser/userapi/user/orgCode/load', options)
  }
}
